import { BuiltinSettings, defaultEnvironment } from '@web/service';
import { version } from './version';

export const environment: BuiltinSettings = {
  ...defaultEnvironment,
  production: true,
  version,
  poEditor: {
    languageId: { da: 8530 },
  },
  companyName: 'PBU Pension',
  availableLanguages: ['da'],
  defaultLanguage: 'da',
  cprRegex: new RegExp('(^\\d{6})-?(\\d{4}$)'),
  defaultCountry: 'DK',
  defaultPhoneCountry: 'DK',
  logoutUrl: 'https://pbu.dk/',
  loadingUrl: 'loading.html',
  logoutSeconds: 420,
  notificationSeconds: 300,
  conditions: [
    {
      type: 'ExternalLink',
      value: 'https://pbu.dk/regler-og-betingelser',
      text: 'cas.viewConditions',
    },
  ],
  header: {
    profileIcon: {
      male: 'user-hair',
      female: 'user-hair-long',
      other: 'user-hair-mullet',
    },
  },
  footer: {
    bgImage: 'images/footer.png',
  },
  footerAdditionalInfo: [
    '© Pædagogernes Pension',
    'CVR-nr. 17340484',
    'https://pbu.dk',
    'Sundkrogsgade 13, DK-2100 København Ø',
  ],
  beneficiary: {
    weightFormat: '1.2-2',
  },
  features: {
    ...defaultEnvironment.features,
    externalContribution: false,
    onboarding: {
      phoneNumber: false,
    },
    language: {
      selector: false,
    },
    edit: {
      tin: false,
    },
    projection: {
      startAtCurrentAge: false,
      scenariosSupported: true,
    },
    membershipNumber: false,
    investmentProfile: false,
    savingsSummaryInfo: true,
    selfServiceAction: {
      hideIfNotAvailable: true,
    },
  },
};
